import { useCallback, useEffect, useMemo, useState } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { updateDynamicStyleIds } from '@alltrails/maps/redux/reducer';
import { useAppDispatch, useAppSelector } from '../redux/helpers';

const useHeatmapsTierValidation = () => {
  const dispatch = useAppDispatch();
  const dynamicStyleIds = useAppSelector(state => state.map.dynamicStyleIds);
  const user = useUser();

  const [hasShownHeatmapsUpsellModal, setHasShownHeatmapsUpsellModal] = useState(false);
  const [showHeatmapsUpsellModal, setShowHeatmapsUpsellModal] = useState(false);
  const onHeatmapsUpsellModalCloseRequest = useCallback(() => setShowHeatmapsUpsellModal(false), []);
  const [heatmapsUpsellModalApplyStylesCallback, setHeatmapsUpsellModalApplyStylesCallback] = useState<() => void>();

  const handleHeatmapFailedEntitlementCheck = useCallback(async (applyStyles: () => void) => {
    setShowHeatmapsUpsellModal(true);
    setHasShownHeatmapsUpsellModal(true);
    setHeatmapsUpsellModalApplyStylesCallback(() => applyStyles);
  }, []);

  useEffect(() => {
    if (hasShownHeatmapsUpsellModal && !showHeatmapsUpsellModal) {
      // After the upsell modal is closed, if the user has the correct entitlement, apply the heatmap, otherwise, remove them
      if (user?.featureEntitlements?.includes('community_heat_maps')) {
        heatmapsUpsellModalApplyStylesCallback?.();
      } else {
        dispatch(updateDynamicStyleIds(dynamicStyleIds.filter(id => id !== 'newHeatmap')));
      }
      setHeatmapsUpsellModalApplyStylesCallback(undefined);
    }
  }, [showHeatmapsUpsellModal]);

  return useMemo(
    () => ({
      showHeatmapsUpsellModal,
      onHeatmapsUpsellModalCloseRequest,
      handleHeatmapFailedEntitlementCheck
    }),
    [handleHeatmapFailedEntitlementCheck, onHeatmapsUpsellModalCloseRequest, showHeatmapsUpsellModal]
  );
};

export default useHeatmapsTierValidation;
